const eChannels = [
  {
    title: 'E-Channels',
    icon: 'CreditCardIcon',
    enableFeature: true,
    children: [
      {
        title: 'Cards',
        enableFeature: true,
        children: [
          {
            title: 'Card Profiles',
            route: 'card-profiles',
            hasPermission: 'VIEW_CARD_PROFILE',
            enableFeature: true,
          },
          {
            title: 'Card Request Log',
            route: 'card-request-log',
            hasPermission: 'VIEW_CARD_REQUEST_LOG',
            enableFeature: true,
          },
          {
            title: 'Host Financial Institutions',
            route: 'host-financial-institutions',
            hasPermission: 'VIEW_HOST_FINANCIAL_INSTITUTION',
            enableFeature: true,
          },
          {
            title: 'Batch Cards request',
            route: 'batch-cards-request-list',
            hasPermission: 'VIEW_CARD_REQUESTS',
            enableFeature: true,
          },
          {
            title: 'Issue Card',
            route: 'issue-card-list',
            hasPermission: 'VIEW_ISSUED_CARDS',
            enableFeature: true,
          },
          {
            title: 'Manage Cards',
            route: 'manage-cards',
            hasPermission: 'MANAGE_CARDS',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Interbank Transfers',
        enableFeature: true,
        children: [
          {
            title: 'Outward Transfers',
            route: 'outward-transfers',
            hasPermission: 'VIEW_TRANSFER_REPORT',
            enableFeature: true,
          },
          {
            title: 'Inward Transfers',
            route: 'inward-transfers',
            hasPermission: 'VIEW_INWARD_TRANSFER_REPORT',
            enableFeature: true,
          },
          {
            title: 'Configurations',
            route: 'interbank-configurations',
            hasPermission: 'VIEW_INTERBANK_TRANSFER_CONFIGURATION',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Internet Banking',
        enableFeature: true,
        children: [
          {
            title: 'Enrolled Customer Profile',
            route: 'enrolled-customer-profile',
            hasPermission: 'VIEW_INTERNET_BANKING_USERS',
            enableFeature: true,
          },
          // {
          //   title: 'Product Profile Setup',
          //   route: 'product-profile-setup',
          //   hasPermission: 'VIEW_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
          //   enableFeature: true,
          // },
          {
            title: 'Theme Setup',
            route: 'theme-setup',
            hasPermission: 'VIEW_THEME',
            enableFeature: true,
          },
          {
            title: 'Accounts Upgrades Request',
            route: 'accounts-upgrades-request',
            hasPermission: 'VIEW_ACCOUNT_UPGRADE_REQUEST',
            enableFeature: true,
          },
          {
            title: 'Configurations',
            route: 'configurations',
            hasPermission: 'VIEW_SECURITY_CONFIG',
            enableFeature: true,
          },
          {
            title: 'CASA Profile Setup',
            route: 'casa-profile-setup',
            hasPermission: 'VIEW_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
            enableFeature: true,
          },
          {
            title: 'FD Profile Setup',
            route: 'fd-profile-setup',
            hasPermission: 'VIEW_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Bills Payment',
        enableFeature: true,
        children: [
          {
            title: 'View Bills Wallet',
            route: 'view-bills-wallet',
            hasPermission: 'VIEW_BILLS_WALLET',
            enableFeature: true,
          },
          {
            title: 'Bills Payment',
            route: 'bills-payment',
            hasPermission: 'VIEW_BILLS_PAYMENT_HISTORY',
            enableFeature: true,
          },
          {
            title: 'Configurations',
            route: 'bills-configurations',
            hasPermission: 'ADD_BILLS_PAYMENT_CONFIG',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Open API',
        route: 'open-api',
        hasPermission: 'SEARCH_API_CLIENTS',
        enableFeature: true,
      },
    ],
  },
]

export default eChannels
